import {Link}from 'react-router-dom';
import "../About/About.css"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import  service3 from '../../image/service3.png'
import  service2 from '../../image/service2.png'
import Aos from 'aos';
import  service5 from '../../image/service5.png'
import  AbMAint from '../../image/AbMAint.jpg'
import  abver from '../../image/abver.jfif'
import  Ablead from '../../image/Ablead.jpg'
import  leadAB from '../../image/leadAB.jfif'





function About (){

Aos.init();

    return(
     <div id="#" >
         <div className=" container-fluid bg-secondary pt-2 pt-lg-5 pb-2 mb-5">
            <div className="container py-5">
                <div className="row row-box align-items-center py-4">
                    <div className="col-md-6 text-center text-md-left">
                        <h1 className="mb-4 mb-md-0 text-white">About Us</h1>
                     </div>
                        <div className="col-md-6 text-center text-md-right">
                            <div className="d-inline-flex align-items-center">
                                <Link className="btn text-white" to="/">Home</Link>
                                <FontAwesomeIcon className="fas fa-angle-right text-white" icon={faAngleRight} />
                              
                                <Link className="btn text-white disabled" to="/About-us">About Us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            


            <section className="featured">
        <div className="container">
            <div className="row">
                <div className="col-md-6 aos-init aos-animate" data-aos="fade-right" data-aos-delay="400" data-aos-duration="800">
                    <div className="title">
                        <h1 className="title-blue">MPEMI... technical activities </h1>
                    </div>
                    <p>
                        <ul>
                            <li>
                            Solar, HVAC and electric installation .

                            </li>
                            <li>
                            Implementation of energy management solutions.
                            </li>
                            <li>
                            Control and diagnosis: Infrared thermography, measurement and analysis of the quality of energy in electrical networks, Ultrasonic diagnosis , energy audit.

                            </li>
                            <li>

                            Study: Sizing of electrical and energy installations, Integration of management solutions (CMMS / GPAO), Metrology.
                            </li>
                        </ul>
                     </p>
                    
                    <a href='/maintenance#Domaines-d’intervention' className="btn ">See More</a>
                </div>
                <div className="col-md-6 aos-init aos-animate" data-aos="fade-left" data-aos-delay="400" data-aos-duration="800">
                    <div className="featured-img">
                        <img className="featured-big" src={AbMAint} alt="Featured 1"/>
                        <img className="featured-small" src={abver} alt="Featured 2"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className="featured">
        <div className="container">
            <div className="row">
                <div className="col-md-6 aos-init aos-animate" data-aos="fade-right" data-aos-delay="400" data-aos-duration="800">
                    <div className="title">
                        <h1 className="title-blue">MPEMI...consulting activities</h1>
                    </div>
                    <p>
                        <ul>
                            <li>
                            Establishment of an efficient management system.
                            </li>
                            <li>
                            Development of the management system by meeting the normative requirements and those of their activities  .                        </li>
                            <li>

                            Help in obtaining their certifications / accreditations.                 
                           </li>
                           <li>
                           Compliance with legal and regulatory requirements related to normative requirements
                           </li>
                           
                        </ul>
                     </p>
                    
                    <a href="/management#accompagnement-iso-9001" className="btn">See More</a>
                </div>
                <div className="col-md-6 aos-init aos-animate" data-aos="fade-left" data-aos-delay="400" data-aos-duration="800">
                    <div className="featured-img">
                        <img className="featured-big" src={Ablead} alt="Featured 1"/>
                        <img className="featured-small" src={leadAB} alt="Featured 2"/>
                    </div>
                </div>
            </div>
        </div>
    </section>




            <section className="services">
        <div className="container">
            <div className="title text-center">
                
                <h1 className="title-blue">Why Choose Us</h1>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-sm-6 col-lg-4">
                        <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                            <img className="mr-4" src={service2} alt="Web Development"/>
                            <div className="media-body">
                                <h5>MPEMI ... Technical Services</h5>
                               <ul>
                                   <li>
                                       Installation
                                   </li>
                                   <li>
                                       Maintenance
                                   </li>
                                   <li>
                                       Non-destructive control
                                   </li>
                                   <li>
                                   Commissioning
                                   </li>

                               </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="400" data-aos-duration="600">
                            <img className="mr-4" src={service3} alt="Web Development"/>
                            <div className="media-body">
                                <h5>MPEMI ... Assistance services</h5>
                                <ul>
                                    <li>
                                     Study
                                    </li>
                                    <li>
                                     Modeling & Sizing 
                                    </li>
                                    <li>
                                    Quality Management  System
                                    </li>
                                    <li>
                                        Zero Carbon
                                    </li>
                                    <li>
                                        Energy Efficiency
                                    </li>
                                </ul>
                               
                            </div>
                        </div>
                    </div>
                    

                    <div className="col-sm-6 col-lg-4">
                        <div className="media aos-init" data-aos="fade-up" data-aos-delay="600" data-aos-duration="800">
                            <img className="mr-4" src={service5} alt="Web Development"/>
                            <div className="media-body">
                                <h5>MPEMI ... Training services</h5>
                                <ul>
                                    <li>
                                    Energy efficiency, solar energy
                                    </li>
                                    <li>
                                    Quality tools: AMDEC, 5S 8D SMED QRQC,...
                                    </li>
                                    <li>
                                    Metrology and Instrumentations
                                    </li>
                                    <li>
                                    ISO 17025
                                    ISO 50001 ,IATF 16949, ...
                                    </li>
                                    <li>
                                    Polymers and Chemical engineering
                                    </li>
                                </ul>
                                

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

  
            
     </div>
    );
}
export default About;